import { AccountActivationStatus } from 'src/graphql/generated';

export const getIsAdvertiserEmailUnverified = (
  activationStatus?: AccountActivationStatus,
) => activationStatus === AccountActivationStatus.PENDING;
